import styled from 'styled-components';
import {
    MIN_TABLET_BREAKPOINT,
    MOBILE_SLIDER_BREAKPOINT,
    SELECTORS
} from '../../constants/constants';

export const GameSliderContainer = styled.section`
    ${SELECTORS} & {
        margin: 100px auto 0 auto;
        width: 90%;
        max-width: 1380px;
        display: block;
    }
    @media (max-width: ${MOBILE_SLIDER_BREAKPOINT}) { 
        ${SELECTORS} & {
          width: 100%;
        }
    }
`;

export const GameSliderTitle = styled.h2`
    ${SELECTORS} & {
        margin: 0 auto 15px 0;
        font-size: 50px;
        line-height: 60px;
        text-align: center;
    } 
  
  @media (max-width: ${MIN_TABLET_BREAKPOINT}) {
    ${SELECTORS} & {
        font-size: 32px;
        line-height: 38px;
        width: 90%;
        margin-left: auto;
        margin-right: auto;
     }
  } 
`;

export const GameSliderDescription = styled.p`
    ${SELECTORS} & {
        font-size: 22px;
        font-weight: 400;
        line-height: 24px;
        text-align: center;
        margin: 35px auto;
        width: 90%;
   }
   @media (max-width: ${MOBILE_SLIDER_BREAKPOINT}) {
    ${SELECTORS} & {
      text-align: left;
      width: 90%;
     }
   } 
`;